/**
 * Палитра серий отчётов. Цвет назначается по индексу набора данных, поэтому
 * график, таблица результата и детальная таблица обязаны брать её из одного места —
 * иначе точка в таблице не совпадёт с цветом линии или сектора.
 *
 * Первые 8 — фиксированный категориальный порядок (blue/orange/aqua/yellow/magenta/
 * green/violet/red), прошедший проверку на различимость соседних цветов при дальтонизме
 * и при обычном зрении (см. dataviz-скилл, validate_palette.js: worst adjacent CVD ΔE
 * 7.5, normal-vision ΔE 16.4 на всех 16 слотах — раньше палитра шла плавным переходом
 * красный→оранжевый→жёлтый, из-за чего первые несколько серий (например, топ стран)
 * были почти неразличимы). Слоты 9–16 — те же 8 оттенков, затемнённые/осветлённые
 * (см. переменную variant в скрипте генерации), чтобы разбивки с 9+ значениями всё ещё
 * получали контрастные цвета, а не повтор с шага 1.
 */
export const SERIES_PALETTE = [
  '#2a78d6', '#eb6834', '#1baf7a', '#eda100', '#e87ba4', '#008300', '#4a3aa7', '#e34948',
  '#215ea7', '#b75129', '#15895f', '#b97e00', '#b56080', '#006900', '#7265ba', '#b13938'
]

/**
 * Палитра UTM-разбивок: первые 5 максимально различимы, дальше добор.
 *
 * Отдельная от SERIES_PALETTE — у UTM-отчётов свой исторический набор цветов,
 * и менять его задним числом значило бы перекрасить все сохранённые отчёты.
 * Раньше этот массив лежал копиями в _chart.vue и _utm_report.vue с пометками
 * «keep in sync»; теперь один источник, чтобы цвет линии совпадал с цветом
 * строки в таблице во всех трёх местах, где он нужен (тренды, UTM-таблица,
 * ретеншен с разбивкой).
 */
export const UTM_PALETTE = [
  '#2563EB', // blue
  '#16A34A', // green
  '#EA580C', // orange
  '#9333EA', // purple
  '#DC2626', // red
  '#0891B2', // cyan
  '#CA8A04', // amber
  '#DB2777', // pink
  '#65A30D', // lime
  '#0D9488', // teal
  '#7C3AED', // violet
  '#C2410C', // burnt orange
  '#1D4ED8', // dark blue
  '#15803D', // dark green
  '#BE123C', // dark red
  '#0369A1', // steel blue
  '#B45309', // brown
  '#7E22CE', // dark purple
  '#9D174D', // dark pink
  '#166534', // deep green
]

export default { SERIES_PALETTE, UTM_PALETTE }
